import { FadeUp, SectionHeading } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "One Team",
    body: "Architect, engineer, and builder sit at the same table from day one. Nothing is lost in translation, because there is no translation.",
    span: "md:col-span-7",
  },
  {
    num: "02",
    title: "One Contract",
    body: "A single point of responsibility. We own the drawing and the ductwork, the rendering and the rebar.",
    span: "md:col-span-5",
  },
  {
    num: "03",
    title: "No Surprises",
    body: "Budgets are drawings too. We price early, build in the open, and finish when we said we would.",
    span: "md:col-span-12",
  },
];

export const Manifesto = () => (
  <section id="studio" className="px-6 md:px-12 py-28 md:py-40" data-testid="manifesto-section">
    <SectionHeading index="Chapter 01 — 03" title="The Manifesto" testId="manifesto-heading" />
    <div className="grid grid-cols-1 md:grid-cols-12 gap-px bg-white/15 border border-white/15">
      {CHAPTERS.map((c, i) => (
        <FadeUp key={c.num} delay={i * 0.12} className={`${c.span} bg-[#050505]`}>
          <div className="group relative p-10 md:p-14 h-full min-h-[280px] flex flex-col justify-between hover:bg-white transition-colors duration-500" data-testid={`manifesto-chapter-${c.num}`}>
            <span className="font-display text-7xl md:text-8xl font-bold leading-none text-white/10 group-hover:text-[#4361C2]/25 transition-colors duration-500">
              {c.num}
            </span>
            <div className="mt-12">
              <h3 className="font-display text-2xl md:text-3xl uppercase font-bold tracking-tight group-hover:text-black transition-colors duration-500">
                {c.title}
              </h3>
              <p className="mt-4 text-sm md:text-base font-light leading-relaxed text-ash group-hover:text-black/70 max-w-lg transition-colors duration-500">
                {c.body}
              </p>
            </div>
          </div>
        </FadeUp>
      ))}
    </div>
  </section>
);
